export const metamaPackage = {
  id: 1,
  title: "مقایسه ویژگی‌های بسته‌های مرکز تماس ابری متاما",
  subTitle: "ویژگی های اصلی",
  packagenames: {
    noghre: "بسته نقره ای",
    talaei: "بسته طلایی",
    opal: "بسته اپال",
  },
  listPack: [
    {
      id: 1,
      title: " فضای ابری (گیگ)",
      noghre: "2",
      talaei: "5",
      opal: "10",
    },
    {
      id: 2,
      title: "داخلی رایگان",
      noghre: "10",
      talaei: "20",
      opal: "30",
    },
  ],
  options: [
    {
      id: 3,
      title: "چت سازمانی (ایجاد گروه، پیام یک به یک)",
      mobile_title: "چت سازمانی",
      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 4,
      title: "امکان ساخت کانال های اطلاع رسانی",
      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 5,
      title: "ویدئو کنفرانس",
      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 6,
      title: "اشتراک گذاری فایل",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 7,
      title: "سرویس دفترچه تلفن",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 9,
      title: "پشتیبانی از تاریخ شمسی/میلادی",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 10,
      title: "پشتیبانی از زبان فارسی/ انگلیسی",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 11,
      title: " تماس صوتی و تصویری یک به یک",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 12,
      title: " دریافت نوتیفیکیشن تماس ",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 13,
      title: "هلد و ترنسفر",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 14,
      title: "امکان مدیریت تماس های همزمان(پشت خطی)",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 15,
      title: "دریافت لیست های وارده و صادره در تب تماس",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 16,
      title: "گزارش تماس‌های بی پاسخ ",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 17,
      title: "دریافت میس کال در حالت آنلاین و آفلاین",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 18,
      title: "کیف پول و امکان شارژ بر روی اپلیکیشن ",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 19,
      title: "مالتی دیوایس (چند دستگاهی)",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 20,
      title: "عدم از دست رفتن سابقه پیام‌ها در صورت نصب مجدد اپلیکیشن",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 21,
      title: "امکان سرچ هوشمند",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 22,
      title: "استیکر",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 23,
      title: "بارگذاری صوت",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 24,
      title: "مدیریت صف",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 25,
      title: "منوی آی وی آر",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 44,
      title: "تماس مجدد با آخرین اپراتور",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 26,
      title: "هدایت تماس‌ها",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 27,
      title: "ضبط مکالمات",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 28,
      title: "گزارش وضعیت اتصال تماس‌ها",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 29,
      title: "گزارش تماس‌های پاسخ داده شده",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 30,
      title: "گزارش تماس‌های بی پاسخ ",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 31,
      title: "گزارش فعالیت اپراتورها",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 32,
      title: "لاگ تماس‌های ضبط شده",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 33,
      title: "تماس امن",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 34,
      title: "پشتیبانی 24/7",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 35,
      title: "امکان تنظیم ساعت کاری",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 37,
      title: "پیامگیر صوتی",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 43,
      title: "لیست سیاه و سفید",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 36,
      title: "تیکتینگ",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 38,
      title: "نظرسنجی",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 39,
      title: "قابلیت استفاده از آی پی فون",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 40,
      title: "گزارش پیشرفته",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 42,
      title: "گزارش پراکندگی",

      packages: {
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 41,
      title: "تعیین سطوح دسترسی",

      packages: {
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 42,
      title: "مانیتورینگ زنده",

      packages: {
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 44,
      title: "کنترل زنده تماس‌ها",

      packages: {
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 45,
      title: "نجوا",

      packages: {
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 46,
      title: "ورود به مکالمه زنده",

      packages: {
        noghre: false,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 40,
      title: "والبورد",

      packages: {
        noghre: false,
        talaei: false,
        opal: true,
      },
    },
    {
      id: 40,
      title: "سرویس اعلان",

      packages: {
        noghre: false,
        talaei: false,
        opal: true,
      },
    },
  ],
};
